import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNN05 from '../actions/actionTypesNN05';
import { getNN05EmployeeIdSaga, getNN05EmployeeIdValidateSaga, getNN05EmployeeListSaga, getNN05LocationByPostalCodeSaga, setTransDeleteEmployeeSaga, setTransInsertEmployeeSaga, setTransUpdateEmployeeSaga } from './NN05.saga';


export function* watchGetNN05EmployeeListSaga() {
  yield takeLatest(actionTypesNN05.NN05_EMPLOYEELIST_GET, getNN05EmployeeListSaga);
}


export function* watchPostNN05EmployeeInsertSaga() {
  yield takeLatest(actionTypesNN05.SET_TRANS_INSERT_EMPLOYEEPOST, setTransInsertEmployeeSaga);
}

export function* watchPostNN05EmployeeUpdateSaga() {
  yield takeLatest(actionTypesNN05.SET_TRANS_UPDATE_EMPLOYEEPOST, setTransUpdateEmployeeSaga);
}

export function* watchPostNN05EmployeeDeleteSaga() {
  yield takeLatest(actionTypesNN05.SET_TRANS_DELETE_EMPLOYEEPOST, setTransDeleteEmployeeSaga);
}

export function* watchGetNN05EmployeeIdSaga() {
  yield takeLatest(actionTypesNN05.NN05_EMPLOYEE_ID_GET, getNN05EmployeeIdSaga);
}

export function* watchGetNN05EmployeeIdValidateSaga() {
  yield takeLatest(actionTypesNN05.NN05_EMPLOYEE_ID_VALIDATE_GET, getNN05EmployeeIdValidateSaga);
}

export function* watchGetNN05LocationByPostalCodeSaga() {
  yield takeLatest(actionTypesNN05.NN05_LOCATION_BY_POSTALCODE_GET, getNN05LocationByPostalCodeSaga);
}